import React from 'react';
import OrdersList from './Orders/OrdersList';

const Orders: React.FC = () => {
  return <OrdersList />;
};

export default Orders; 